import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
import SkillPill from '@/modules/corporate/components/SkillPill';

import { ReadonlySkillsProps } from './types';

export default function ReadonlySkills({ skills }: ReadonlySkillsProps) {
  return (
    <Stack className={cn('flex-wrap gap-x-8 gap-y-12 xs:px-18 pb-16')} direction="row">
      {skills.map((skill) => (
        <SkillPill key={skill.id} skill={skill} />
      ))}
    </Stack>
  );
}
